<template lang="pug">
div
  v-divider.mb-1.mt-6.neutral700
  .text-xxs.italic.neutral500--text This certificate was generated digitally. No signature needed for this document
</template>

<script>
export default { 
}
</script>

<style lang="scss" scoped>
</style>